import React from "react";
import { Box } from "@mui/material";

import { STATUS_COLORS_OPACITY } from "../../../constants";

interface IProps {
  children: React.ReactNode;
  failedPayment: boolean;
  refundPayment: boolean;
  ownCharge: boolean;
}
export const TableRow: React.FC<IProps> = ({
  children,
  failedPayment,
  refundPayment,
  ownCharge,
}) => {
  const failedPaymentStyles = {
    backgroundColor: "#ffff0000",
    borderBottom: "1px solid #000",
    borderTop: "1px solid #000",
    "& td": {
      backgroundColor: "#ffff003b !important",
    },
  };
  const ownChargeStyles = {
    backgroundColor: STATUS_COLORS_OPACITY.lightGreen,
  };
  const refundPaymentStyles = {
    backgroundColor: "#ffff0000",
    borderBottom: "1px solid #000",
    borderTop: "1px solid #000",
    "& td": {
      backgroundColor: STATUS_COLORS_OPACITY.lightRed,
    },
  };

  return (
    <Box
      sx={{
        ...(failedPayment && failedPaymentStyles),
        ...(refundPayment && refundPaymentStyles),
        ...(ownCharge && ownChargeStyles),
      }}
      component="tr"
    >
      {children}
    </Box>
  );
};
